import { App } from 'vue'
import config from './sensorsdata/qtconfig'

import { bridge } from './bridge/index'

type QTOptions = {
  sdk: string
  appKey: string
  aplus_host: string
  platformName: string
  show_log: boolean
  'aplus-jsbridge-only': boolean
}

class QT {
  options
  constructor() { }
  init(options: QTOptions) {
    this.options = options || {}
      ; (function (w, d, s, q) {
        w[q] = w[q] || []
        const f: any = d.getElementsByTagName(s)[0],
          j: any = d.createElement(s)
        j.async = true
        j.id = 'beacon-aplus'
        j.src = options.sdk // 初始化sdk
        j.onload = () => {
          console.log('sdk init success')
        }
        f.parentNode.insertBefore(j, f)
      })(window, document, 'script', 'aplus_queue')
    //集成应用的appKey
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['appKey', options.appKey],
    })
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-rhost-v', options.aplus_host],
    })
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-autotrack-enabled', true],
    })
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: [
        'aplus-autotrack-config',
        {
          collect_tags: {
            li: true, //采集<li/>控件
            img: true, //采集<img/>控件
            svg: true, //采集<svg/>控件
            div: true, //采集<div/>控件
            span: true, //采集<span/>控件
            path: true, //采集<path/>控件
            i: true,
            p: true, //采集<p/>控件
          },
          collect_input: true, //采集input框输入的内容，默认不采集,
          element_capture_enable: true, //全埋点控件点击支持事件捕获模式，默认为冒泡模式，值为false
        },
      ],
    })

    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: [
        'aplus-auto-clk-userfn',
        function (e) {
          if (e.className.indexOf('autotrack_clk_web') != -1) {
            let dataset = e.dataset
            let obj: any = {}
            obj.itemID = dataset.itemid
            obj.itemName = dataset.itemname
            obj.itemZoon = dataset.itemzoon
            obj.promotionInformation = dataset.promotioninformation
            obj.pageName = dataset.pagename
            return {
              userdata: obj,
            }
          }
        },
      ],
    })
    if (options.show_log) {
      window.aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['DEBUG', true] })
    }

    try {
      let userInfo = bridge.userInfo() || null
      if (userInfo) {
        window.aplus_queue.push({
          action: 'aplus.setMetaInfo',
          arguments: ['_user_id', userInfo.userId],
        })
        window.aplus_queue.push({
          action: 'aplus.setMetaInfo', //覆盖全局属性
          arguments: [
            'globalproperty',
            {
              nick_name: userInfo?.nickName || '',
              isCarOwner: userInfo.isCarOwner,
              nick: userInfo?.nick || '',
            },
          ],
        })
      }
    } catch (error) {
      console.log(error)
    }
  }
  /**
   *  设置用户账号
   */
  setMetaInfo(user_id: string) {
    if (user_id) {
      window.aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['_user_id', user_id],
      })
    }
  }
  /**
   *
   * @param params 设置用户属性
   */
  setUserProfile(params: Record<string, string>) {
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: ['$$_user_profile', 'OTHER', params],
    })
  }
  /**
   *
   * @param params 设置全局属性
   */
  setGlobalproperty(params: Record<string, string>) {
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo', //覆盖全局属性
      arguments: ['globalproperty', params],
    })
  }
  /**
   * 追加全局属性
   * @param params
   */
  appenGlobalproperty(params: Record<string, string>) {
    console.log('--appenGlobalproperty---', params)
    window.aplus_queue.push({
      action: 'aplus.appendMetaInfo',
      arguments: ['globalproperty', params],
    })
  }
  /**
   *
   * @param event CLK 点击 | EXP 曝光 | OTHER 其他事件
   * @param params
   */
  track(event: { type?: string; eventName: string }, params: Record<string, string | Number>) {
    const { type, eventName } = event
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [eventName, type || 'CLK', params],
    })
  }

  // 曝光埋点
  exposure(event: { eventClass: string; eventName: string; params: string[] }) {
    const { eventClass, eventName, params } = event
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: [
        'aplus-auto-exp',
        [
          {
            cssSelector: eventClass,
            logkey: eventName,
            props: params, // 你要曝光的元素身上自定义属性
          },
        ],
      ],
    })
  }
}

const qt = new QT()

const install = (app: App<Element>) => {
  let env = 'prod'
  if (import.meta.env.VITE_NODE_ENV !== 'production') {
    env = 'test'
  }
  const QTConfig: QTOptions = config[env]
  const inApp = bridge.support('userInfo') ? true : false
  // console.log('inApp', bridge.brand)
  qt.init({
    sdk: QTConfig.sdk,
    appKey: inApp && (bridge.brand == 10) ? '' : QTConfig.appKey,
    aplus_host: QTConfig.aplus_host,
    platformName: QTConfig.platformName,
    show_log: import.meta.env.VITE_NODE_ENV !== 'production',
    'aplus-jsbridge-only': inApp && (bridge.brand == 10) ? true : false, // true：关闭H5的日志发送，一般为桥接场景下可控制只发送桥接日志 false：打开H5的日志发送（默认false）
  })
  app.config.globalProperties.$qt = qt
}

export default {
  install,
  qt,
}
